import { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom"
import { v4 as uuid } from 'uuid';
// ------ Services ------ //
import * as leadCaptureService from '../../../services/leadCaptureService'
import * as siteManagementService from '../../../services/siteManagementService'
// ------ Styles ------ //
import styles from "./ExhibitorConfig.module.css"
// ------ Components ------ //
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import LCProductOrder from "../../../components/LeadCapture/ExhibitorConfig/LCProductOrder"
import LoadingSpinner from '../../../components/Miscellaneous/LoadingSpinner'
const ExhibitorConfig = () => {
    const navigate = useNavigate()
    const [loaded, setLoaded] = useState(false)
    const [manualOverride, setManualOverride] = useState(false)
    const [products, setProducts] = useState([])
    const [totalCost, setTotalCost] = useState(0);
    const [eventProducts, setEventProducts] = useState([])
    const [exhibitorProducts, setExhibitorProducts] = useState([])
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [attachments, setAttachments] = useState([])
    const [message, setMessage] = useState([''])
    const [passcodeError, setPasscodeError] = useState(false)
    const [editingId, setId] = useState();
    const [eventItem, setEventItem] = useState({})
    const [file, setFile] = useState();
    const unique_id = uuid();
    const [passcode, setPasscode] = useState([''])
    const location = useLocation()
    const exhibitor = location.state
    const [formData, setFormData] = useState(
        {
            id: exhibitor && exhibitor.id ? exhibitor.id : unique_id,
            leadCaptureId: exhibitor && exhibitor.leadCaptureId ? exhibitor.leadCaptureId : exhibitor.current ? exhibitor.current.leadCaptureId : null,
            leadCaptureName: null,
            address: null,
            city: null,
            organization: null,
            countryName: exhibitor && exhibitor.country && exhibitor.country.countryName !== undefined ? exhibitor.country.countryName : 'United States',
            country: exhibitor && exhibitor.country ? exhibitor.country: {},
            stateName: exhibitor && exhibitor.state && exhibitor.state.stateName !== undefined ? exhibitor.state.stateName : null,
            state: exhibitor && exhibitor.state ? exhibitor.state : {},
            email: null,
            firstName: null,
            lastName: null,
            passcode: null,
            postalCode: null,
            mobileImage: [],
            mobileBase64Image: null,
            mobileImageExtension: 'jpg',
            cancelled: false,
        }
    )
    const updateProducts = async () => {
        if (products && products.length > 0) {
            let prodHolder = products;
            // merge the event products and the productorder
            let tempProducts = [];
            if (eventProducts && eventProducts.length > 0) {
                for (var i = 0; i < products.length; i++) {
                    let prod = prodHolder[i];
                    let foundItem = eventProducts.filter(x => x.id === prod.id);
                    if (foundItem && foundItem.length > 0) {
                        if (foundItem[0].skuName && foundItem[0].skuName !== undefined) {
                            prod.skuName = foundItem[0].skuName;
                        }
                        if (foundItem[0].name && foundItem[0].name !== undefined) {
                            prod.name = foundItem[0].name;
                        }
                        if (foundItem[0].description && foundItem[0].description !== undefined) {
                            prod.description = foundItem[0].description;
                        }
                        if (foundItem[0].showQuantity && foundItem[0].showQuantity !== undefined) {
                            prod.showQuantity = foundItem[0].showQuantity;
                        }
                        if (foundItem[0].pdfAttachment && foundItem[0].pdfAttachment !== undefined) {
                            prod.pdfAttachment = foundItem[0].pdfAttachment;
                        }
                        if (foundItem.usePromoCode && foundItem[0].usePromoCode !== undefined) {
                            prod.usePromoCode = foundItem[0].usePromoCode;
                        }
                        if (foundItem[0].promoCodes && foundItem.promoCodes !== undefined) {
                            prod.promoCodes = foundItem[0].promoCodes;
                        }
                    }
                    tempProducts.push(prod);
                }
            }
            if (exhibitorProducts && exhibitorProducts.length > 0) {
                if (tempProducts && tempProducts.length > 0) {
                    prodHolder = tempProducts;
                }
                tempProducts = [];
                for (var i = 0; i < products.length; i++) {
                    let prod = prodHolder[i];
                    let foundItem = exhibitorProducts.filter(x => x.productId === prod.id);
                    if (foundItem && foundItem.length > 0) {
                        if (foundItem[0].quantity && foundItem[0].quantity !== undefined) {
                            prod.quantity = foundItem[0].quantity;
                        }
                        if (foundItem[0].purchasePrice && foundItem[0].purchasePrice !== undefined) {
                            prod.purchasePrice = foundItem[0].purchasePrice;
                        }
                        if (foundItem[0].quantity && foundItem[0].quantity !== undefined &&
                            foundItem[0].purchasePrice && foundItem[0].purchasePrice !== undefined) {
                            prod.total = foundItem[0].quantity * foundItem[0].purchasePrice;
                        }
                        if (foundItem[0].cancelled && foundItem[0].cancelled !== undefined) {
                            prod.cancelled = foundItem[0].cancelled;
                        }
                        if (foundItem[0].isAdmin && foundItem[0].isAdmin !== undefined) {
                            prod.isAdmin = foundItem[0].isAdmin;
                        }
                    }
                    tempProducts.push(prod);
                }
            }

            setProducts(tempProducts)
        }
        else {
            setProducts(exhibitorProducts && exhibitorProducts.length > 0 ? exhibitorProducts : eventProducts);
        }
    }
    const updateTotalCost = async () => {
        let newCost = 0
        if (products && products.length > 0) {
            products.forEach((item) => {
                if (item.total && item.total > 0 && (!item.cancelled || (item.cancelled && item.cancelled === false))) {
                    newCost += item.total;
                }
            })
            setTotalCost(newCost);
        }
    }
    const fetchAttachments = async () => {
        const attachmentItems = await siteManagementService.getAttachmentsByType('marketing');
        if (attachmentItems && attachmentItems.length > 0) {
            setAttachments(attachmentItems);
        }
        else {
            setAttachments([]);
        }
    }
    const fetchEvent = async (leadCaptureId) => {
        const eventItem = await leadCaptureService.getEvent(leadCaptureId);
        // set formdata
        if (eventItem) {
            setEventItem(eventItem);
            setEventProducts(eventItem.products);
            if (eventItem.mobileBase64Image) {
                // set the exhibitor image
                setFormData({ ...formData, mobileBase64Image: eventItem.mobileBase64Image, mobileImageExtension: eventItem.mobileImageExtension });
                setFile(eventItem.mobileBase64Image);
            }
        }
    }
    const fetchExhibitor = async () => {
        const exhibitorItem = await leadCaptureService.getExhibitor(formData.id);
        // set formdata
        if (exhibitorItem) {
            exhibitorItem.countryName = exhibitorItem && exhibitorItem.country && exhibitorItem.country.countryName !== undefined ? exhibitorItem.country.countryName : 'United States';
            exhibitorItem.stateName = exhibitorItem && exhibitorItem.state && exhibitorItem.state.stateName !== undefined ? exhibitorItem.state.stateName : null;
            setFormData(exhibitorItem);
            setExhibitorProducts(exhibitorItem.invoice.productOrders);
        }
        setLoaded(true);
    }
    const createPasscodeRequest = (newPasscode) => {
        const fields = {
            passcode: newPasscode,
            id: formData.id,
        }

        return fields
    }
    const validatePasscode = async (newPasscode) => {
        const passcodeItem = await leadCaptureService.checkPasscode(passcode);
        // false means unique, true passcode is in use
        if (passcodeItem && passcodeItem === true) {
            setPasscodeError(true);
        }
        else {
            setPasscodeError(false);
        }
    }
    const fetchPasscode = async (newPasscode) => {
        const pascodeReq = createPasscodeRequest(newPasscode);
        const passcodeItem = await leadCaptureService.retrievePasscode(pascodeReq);
        // set formdata
        if (passcodeItem) {
            setPasscode(passcodeItem)
        }
    }
    const editProductOrder = e => {
        e.preventDefault()
        let divId = e.currentTarget.id
        //if (!divId) {
        //    e.current.id
        //}
        const items = Array.from(products)
        let filtered = items[divId]

        // Have to add this to maintain one edit at a time, since all will share formData for editing state
        const editableCheck = i => i.editable
        if (items.some(editableCheck)) {
            return
        }
        filtered.editable = true
        setId(divId)
    }
    const submitEdit = (e, prodItem) => {
        e.preventDefault()
        let divId = e.currentTarget.id
        const items = Array.from(products)
        let filtered = items[divId]
        filtered.editable = false;
        filtered.quantity = prodItem.quantity;
        filtered.purchasePrice = prodItem.purchasePrice;
        filtered.promoCode = prodItem.promoCode;
        filtered.cancelled = prodItem.cancelled;
        filtered.isAdmin = prodItem.isAdmin;
        filtered.total = (!prodItem.cancelled || (prodItem.cancelled && prodItem.cancelled === false)) && prodItem.quantity && prodItem.quantity !== undefined &&
            prodItem.purchasePrice && prodItem.purchasePrice !== undefined ? prodItem.quantity * prodItem.purchasePrice : 0;
        items.splice(divId, 1, filtered);
        setProducts(items);
        setId(null)
        updateTotalCost();
    }

    const deleteProductOrder = e => {
        e.preventDefault()
        let divId = e.currentTarget.id
        //if (!divId) {
        //    e.current.id
        //}
        const items = Array.from(products)
        let filtered = items[divId]
        let trimmed = [];
        for (var i = 0; i < items.length; i++) {
            if (items[i] === filtered) {
                trimmed = items.splice(i, 1);
                i--;
            }
        }
        setProducts(items);
        // Have to add this to maintain one edit at a time, since all will share formData for editing state
        const editableCheck = i => i.editable
        if (!items.some(editableCheck)) {
            return
        }
        filtered.editable = false
        setId(null)
        updateTotalCost();
    }

    const cancelEdit = e => {
        e.preventDefault()
        let divId = e.currentTarget.id
        //if (!divId) {
        //    e.current.id
        //}
        const items = Array.from(products)
        let filtered = items[divId]

        // Have to add this to maintain one edit at a time, since all will share formData for editing state
        const editableCheck = i => i.editable
        if (!items.some(editableCheck)) {
            return
        }
        filtered.editable = false
        setId(null)
        updateTotalCost();
    }
    const handleChange = (e) => {
        if (e.target.type === 'select-one') {
            if (e.target.name === 'stateName') {
                var foundState = states.find((item) => item.stateName === e.target.value);
                if (foundState) {
                    setFormData({ ...formData, state: foundState, stateName: foundState.stateName })
                }
                else {
                    setFormData({ ...formData, state: {}, stateName: null })
                }

            }
            if (e.target.name === 'countryName') {
                var foundCountry = countries.find((item) => item.countryName === e.target.value);
                if (foundCountry) {
                    setFormData({ ...formData, country: foundCountry, countryName: foundCountry.countryName  })
                }
                else {
                    setFormData({ ...formData, country: {}, countryName: null })
                }

            }
        }
        else if (e.target.type === 'checkbox') {
            setFormData({
                ...formData,
                [e.target.name]: e.target.checked,
            })
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
            if (e.target.name === 'passcode') {
                setManualOverride(true);
                setPasscode(e.target.value);
            }
        }
    }
    const clearForm = () => {
        let holder = exhibitor && exhibitor.leadCaptureId ? exhibitor.leadCaptureId : exhibitor.current ? exhibitor.current.leadCaptureId : null;
        setFormData({
            id: unique_id,
            leadCaptureId: holder,
            leadCaptureName: null,
            address: null,
            city: null,
            organization: null,
            countryName: 'United States',
            stateName: null,
            email: null,
            firstName: null,
            lastName: null,
            passcode: null,
            postalCode: null,
            mobileImage: [],
            mobileBase64Image: null,
            mobileImageExtension: 'jpg',
            cancelled: false,
        })
        setPasscode(null);
        setPasscodeError(false);
        setManualOverride(false);
        fetchEvent(holder);
    }
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {
                const base64 = reader.result.split(',')[1]
                resolve(base64)
            }
            reader.onerror = (error) => {
                reject(error)
            }
        })
    }
    const getCountries = async () => {
        let countrieslist = await siteManagementService.getCountries();
        if (countrieslist && countrieslist.length > 0) {
            // reorder countries so US is first
            let USA = countrieslist.find((item) => item.countryKey === 'US');
            let OtherCountries = countrieslist.filter((item) => item.countryKey !== 'US');
            OtherCountries.unshift(USA);
            setCountries(OtherCountries)
        }
        else {
            setCountries(countrieslist)
        }

    }
    const getStates = async () => {
        let stateList = await siteManagementService.getStates();
        setStates(stateList)
    }
    const createSaveRequest = (items) => {
        let amountPaid = 0;
        let productOrdersItem = [];
        for (var i = 0; i < products.length; i++) {
            let item = products[i];
            let productOrderItem = {
                'id': item.id ? item.id : null,
                'productId': item.id,
                'quantity': item.quantity,
                'purchasePrice': item.purchasePrice,
                'cancelled': item.cancelled,

            };
            if (item.quantity && item.purchasePrice) {
                // keep a runnning tally
                amountPaid += (item.quantity * item.purchasePrice);
            }
            productOrdersItem.push(productOrderItem);
        }
        let orderItem = {
            'id': formData.order && formData.order.id ? formData.order.id : null, 
            'orderTotal': amountPaid,
            'paid': true,
            'bypassPayment': true, // all creations from this site bypass payment
            'cancelled': formData.cancelled,
        }
        // holder products and porductorders
        let invoiceItem = {
            'id': formData.invoice && formData.invoice.id ? formData.invoice.id : null, 
            'invoiceNumber': formData.invoice && formData.invoice.invoiceNumber ? formData.invoice.invoiceNumber : null, 
            'productOrders': productOrdersItem,
            'order': orderItem,
        }
        // holds everything
        const fieldsSave = {
            'exhibitorId': formData.id,
            'leadCaptureId': formData.leadCaptureId,
            'invoice': invoiceItem,
            'passcode': passcode,
            'organization': formData.organization,
            'firstName': formData.firstName,
            'lastName': formData.lastName,
            'email': formData.email,
            'address': formData.address,
            'city': formData.city,
            'stateName': formData.stateName,
            'countryName': formData.countryName,
            'postalCode': formData.postalCode,
            'mobileBase64Image': formData.mobileBase64Image ? formData.mobileBase64Image : null,
            'mobileImageExtension': formData.mobileImageExtension ? formData.mobileImageExtension : 'jpg',
        }
        return fieldsSave
    }
    const handleSubmit = async e => {
        e.preventDefault()
        try {
            let saveReq = createSaveRequest();
            await leadCaptureService.updateExhibitor(saveReq);
            navigate('/ExhibitorList');
        } catch (err) {
            setMessage(err.message)
        }
    }
    async function handleFileChange(e) {
        //https://stackoverflow.com/questions/39092859/get-dimensions-of-image-with-react
       // console.log(e.target.files);
        setFile(URL.createObjectURL(e.target.files[0]));
        //formData.headerImageExtension = e.target.files[0].type;
        formData.mobileBase64Image = await getBase64(e.target.files[0]);
    }
    const isFormValid = () => {
        return formData.firstName
            && formData.lastName
            && formData.email
            && formData.organization
            && passcode
            ? true
            : false
    }
    useEffect(() => {
        if ((exhibitorProducts && exhibitorProducts.length > 0) || (eventProducts && eventProducts.length > 0)) {
            updateProducts();
            updateTotalCost();
        }

    }, [exhibitorProducts, eventProducts])
    useEffect(() => {
        // check if passcode is unique:
        if (passcode && passcode.length > 1) {
            validatePasscode(passcode);
        }
    }, [passcode])
    useEffect(() => {
        // create/update passcode
        if (formData.organization && formData.organization !== undefined && formData.organization.length < 12 && !manualOverride) {
            fetchPasscode(formData.organization);
        }
    }, [formData.organization])
    useEffect(() => {
        // create/update passcode
        if (eventItem && eventItem !== undefined && eventItem !== {} && eventItem.products) {
            if (exhibitor && exhibitor.leadCaptureId) {
                //setFormData(exhibitor);
                fetchExhibitor(exhibitor.id);
                setManualOverride(true);
                setPasscode(exhibitor.passcode);
            }
            else {
                setFormData({
                    ...formData,
                    id: unique_id,
                })
                setLoaded(true);
            }
        }
    }, [eventItem])
    useEffect(() => {
        // used for dropdowns
        fetchAttachments();
        getCountries();
        getStates();
        
        let leadCaptureId = exhibitor && exhibitor.leadCaptureId ? exhibitor.leadCaptureId : exhibitor.current ? exhibitor.current.leadCaptureId : null;
        if (leadCaptureId) {
            fetchEvent(leadCaptureId);
        }
        else {
            setLoaded(true);
        }
    }, [])

    return (
        <>{loaded ?
            <> 
                {exhibitor.id ?
                    <>
                        <h1>Edit Exhibitor</h1>
                        <div className={styles.exhibitorContainer}>
                            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button><br /><br />
                            <label htmlFor="cancelled" className={styles.label}>Cancel Order:
                            <input
                                type="checkbox"
                                autoComplete="off"
                                checked={formData.cancelled ? true : false}
                                name="cancelled"
                                onChange={handleChange}
                            />
                            </label>
                            <label>Cancelled orders will not show in reports and passcodes/licenses/logins will not work. <br/>Note: can be reversed by admin.</label>
                        </div>
                    </>
                    
                    :
                    <h1>Add Exhibitor</h1>
                }
                <div className={styles.exhibitorContainer}>
                    <h2>Profile</h2>
                    <div className={styles.parentContainer}>
                        <div className={styles.leftContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="firstName" className={styles.label}>First Name:
                                        <HoverButton
                                            title={'Exhibitor first name.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <input
                                        tabIndex='1'
                                        type="text"
                                        autoComplete="off"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.rightContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="lastName" className={styles.label}>Last Name:
                                        <HoverButton
                                            title={'Exhibitor last name.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <input
                                        tabIndex='2'
                                        type="text"
                                        autoComplete="off"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.parentContainer}>
                        <div className={styles.leftContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="email" className={styles.label}>Email Address:
                                        <HoverButton
                                            title={'Exhibitor email.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <input
                                        tabIndex='3'
                                        type="text"
                                        autoComplete="off"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.rightContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="organization" className={styles.label}>Organization:
                                        <HoverButton
                                            title={'Exhibitor organization.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <input
                                        tabIndex='4'
                                        type="text"
                                        autoComplete="off"
                                        name="organization"
                                        value={formData.organization}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.parentContainer}>
                        <div className={styles.leftContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="address" className={styles.label}>Street Address:
                                        <HoverButton
                                            title={'Exhibitor street address.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <input
                                        tabIndex='5'
                                        type="text"
                                        autoComplete="off"
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.rightContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="city" className={styles.label}>City:
                                        <HoverButton
                                            title={'Exhibitor city.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <input
                                        tabIndex='6'
                                        type="text"
                                        autoComplete="off"
                                        name="city"
                                        value={formData.city}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.parentContainer}>
                        <div className={styles.leftContainer}>
                            <div className={styles.parentContainer} key={formData.countryName}>
                                {
                                    formData.countryName && formData.countryName === 'United States' ?
                                        <>
                                            <div className={styles.leftContainer}>
                                                <label htmlFor="stateName" className={styles.label}>State:
                                                    <HoverButton
                                                        title={'Exhibitor state.'}
                                                        messageWidth={75}
                                                    />
                                                </label>
                                            </div>
                                            <div className={styles.rightContainer}>
                                                <select
                                                    tabIndex='7'
                                                    name="stateName"
                                                    id={styles.ThirdPartyListDropdown}
                                                    value={formData.stateName}
                                                    onChange={handleChange}
                                                >
                                                    <option disabled={true} value="" selected="selected">
                                                        -- Select an option --
                                                    </option>
                                                    {
                                                        states.map((ci, idx) => (
                                                            <option key={idx}>{ci.stateName}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </>
                                     : <>
                                        </>
                                }
                                
                            </div>
                        </div>
                        <div className={styles.rightContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="countryName" className={styles.label}>Country:
                                        <HoverButton
                                            title={'Exhibitor country.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <select
                                        tabIndex='8'
                                        name="countryName"
                                        id={styles.ThirdPartyListDropdown}
                                        value={formData.countryName}
                                        onChange={handleChange}
                                    >
                                        <option disabled={true} value="" selected="selected">
                                            -- Select an option --
                                        </option>
                                        {
                                            countries.map((ci, idx) => (
                                                <option key={idx}>{ci.countryName}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.parentContainer}>
                        <div className={styles.leftContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="postalCode" className={styles.label}>Postal Code:
                                        <HoverButton
                                            title={'Exhibitor postal code.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                </div>
                                <div className={styles.rightContainer}>
                                    <input
                                        tabIndex='9'
                                        type="text"
                                        autoComplete="off"
                                        name="postalCode"
                                        value={formData.postalCode}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={styles.rightContainer}>
                            <div className={styles.parentContainer}>
                                <div className={styles.leftContainer}>
                                    <label htmlFor="passcode" className={styles.label}>Passcode:
                                        <HoverButton
                                            title={'Exhibitor passcode.'}
                                            messageWidth={75}
                                        />
                                    </label>
                                    {passcodeError && passcodeError !== false ? 
                                        <div>
                                            <div className={styles.errorEventsMessage}> Passcode is not unique!</div>
                                        </div>
                                    :<></>}
                                </div>
                                <div className={styles.rightContainer}>
                                    <input
                                        tabIndex='10'
                                        type="text"
                                        autoComplete="off"
                                        name="passcode"
                                        value={passcode}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.parentContainer}>
                        <h4>Mobile Image Option </h4>
                        <h3>Image should be close to 400x100.
                        </h3>
                        <h3>Mobile Image:</h3>
                        <img src={file} />
                        <input type="file" onChange={handleFileChange} name="mobileImage" />
                        <div className={styles.inputContainer}>
                            <label className={styles.label} title="Extension of image, can't be changed.">
                                Mobile Image Extension: <input
                                    tabIndex='11'
                                    type="text"
                                    value={formData.mobileImageExtension}
                                    name="mobileImageExtension"
                                    onChange={handleChange}
                                    disabled={true}
                                />

                            </label>
                        </div>
                    </div>
                </div>
                <div className={styles.tableProductsContainer}>
                    <h2>Products</h2>
                    <table className={styles.tableProducts}>
                        <thead>
                            <tr className={styles.trProducts}>

                                <th className={styles.thProducts} style={{ width: '7%' }}>
                                    SKU
                                    <HoverButton
                                        title={'SKU (Stock Keeping Unit) - inventory id.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '15%' }}>
                                    Name
                                    <HoverButton
                                        title={'Label for product.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '25%' }}>
                                    Description
                                    <HoverButton
                                        title={'Description for product.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '5%' }}>
                                    Purchase Price
                                    <HoverButton
                                        title={'Price paid.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '5%' }}>
                                    Quantity
                                    <HoverButton
                                        title={'Amount to order.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '12%' }}>
                                    PDF Attachment
                                    <HoverButton
                                        title={'PDF to be used for product details.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '8%' }}>
                                    Promo Codes
                                    <HoverButton
                                        title={'Pormo code used in purchase.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '8%' }}>
                                    Cancelled
                                    <HoverButton
                                        title={'.'}
                                        messageWidth={75}
                                    />
                                </th>
                                <th className={styles.thProducts} style={{ width: '4%' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody key={products.length}>
                            {products.map((item, index) => (
                                <LCProductOrder
                                    index={index}
                                    productOrderItem ={item}
                                    editProductOrder = { editProductOrder }
                                    submitEdit={submitEdit}
                                    deleteProductOrder = { deleteProductOrder }
                                    cancelEdit={cancelEdit}
                                    editingId={editingId}
                                    attachments={attachments}
                                    key={index}
                                ></LCProductOrder>
                            ))}
                        </tbody>
                    </table>
                </div>
                <br /><br />
                <div className={styles.parentContainer}>
                    <div className={styles.leftContainer}>
                    </div>
                    <div className={styles.rightContainer}>
                        <strong> Total Cost: </strong>{totalCost && totalCost !== undefined ? '$ ' + totalCost.toLocaleString('en-US') : 0}
                    </div>
                </div>
                <br /><br />
                <div className={styles.submitButton}>
                    <button disabled={!isFormValid()} className={styles.button} onClick={handleSubmit}>
                        Submit
                    </button>
                </div>
                <br /><br />
                <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
            </>
            :
            <LoadingSpinner />
        }
        </>

    );
}

export default ExhibitorConfig;